import { URLs } from "../url";
import { PageActionFlags } from "../../model/pageActionFlags";
import { getHeader } from "../headers";
import { handleUnauthorized } from "../fetchRequest";

const getPageActionFlags = async (
  projectId: string,
  clientId: string,
  enable: boolean,
  page: number,
  limit: number
) => {
  let newURL =
    process.env.REACT_APP_HOST_API +
    URLs.pageActionFlags +
    `?projectId=${projectId}&clientId=${clientId}&enable=${enable}&page=${page}&limit=${limit}`;
  const requestOptions = {
    method: "GET",
    headers: getHeader(),
  };

  try {
    const response = await fetch(newURL, requestOptions);
    if (!response.ok) {
      handleUnauthorized(response.status);
      throw await response.json();
    }
    return (await response.json()) as PageActionFlags;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const postPageActionFlags = async (body: any) => {
  const newURL = process.env.REACT_APP_HOST_API + URLs.pageActionFlags;
  const requestOptions = {
    method: "POST",
    body: JSON.stringify({ data: body }),
    headers: getHeader(),
  };
  try {
    const response = await fetch(newURL, requestOptions);
    if (!response.ok) {
      handleUnauthorized(response.status);
      throw await response.json();
    }
    return (await response.json()) as PageActionFlags;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export { getPageActionFlags, postPageActionFlags };
